import { Database, Table, AlertTriangle, Clock } from 'lucide-react';
import type { FabricData } from '../types';
import { getRelativeTime } from '../utils/formatting';
import { MetricCard } from './MetricCard';

interface SummaryCardsProps {
  data: FabricData | null;
}

export function SummaryCards({ data }: SummaryCardsProps) {
  const totalDatabases = data?.summary?.length ?? 0;
  const totalTables = data?.tables?.length ?? 0;
  const failedCount =
    data?.summary?.reduce(
      (sum, db) => sum + db.number_of_tables_in_failed_state,
      0
    ) ?? 0;
  const lastUpdated = data?.last_updated ?? null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <MetricCard
        title="Databases"
        value={totalDatabases.toLocaleString()}
        icon={Database}
        colorClass="bg-blue-500/15 text-blue-400"
        tooltip={`${totalDatabases} mirrored database${totalDatabases !== 1 ? 's' : ''} monitored`}
      />
      <MetricCard
        title="Tables"
        value={totalTables.toLocaleString()}
        icon={Table}
        colorClass="bg-green-500/15 text-green-400"
        tooltip={`${totalTables} table${totalTables !== 1 ? 's' : ''} across all databases`}
      />
      <MetricCard
        title="Failed"
        value={failedCount.toLocaleString()}
        icon={AlertTriangle}
        colorClass={
          failedCount > 0
            ? 'bg-red-500/15 text-red-400'
            : 'bg-gray-500/15 text-gray-400'
        }
        tooltip={
          failedCount > 0
            ? `${failedCount} table${failedCount !== 1 ? 's' : ''} in failed state`
            : 'No tables in failed state'
        }
      />
      <MetricCard
        title="Last Refresh"
        value={getRelativeTime(lastUpdated)}
        icon={Clock}
        colorClass="bg-purple-500/15 text-purple-400"
        tooltip={lastUpdated ? `Last updated: ${new Date(lastUpdated).toLocaleString()}` : 'Never refreshed'}
      />
    </div>
  );
}
